const TokenKey = 'Admin-Token';
/**
 * 从 Cookie 中获取 Token
 * @returns Token 字符串或 undefined
 */
export function getToken() {
    // 原生 Cookie 格式："key1=value1; key2=value2; ..."
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [key, value] = cookie.trim().split('=');
        if (key === TokenKey) {
            return decodeURIComponent(value); // 解码特殊字符
        }
    }
    return undefined;
}
/**
 * 设置 Token 到 Cookie
 * @param token 要存储的 Token 字符串
 * @returns 存储的 Token（便于链式调用）
 */
export function setToken(token) {
    // 原生设置 Cookie：key=value; path=/（path=/ 确保全站可访问）
    document.cookie = `${TokenKey}=${encodeURIComponent(token)}; path=/`;
    return token;
}
/**
 * 从 Cookie 中移除 Token
 */
export function removeToken() {
    // 移除 Cookie 的方式：设置过期时间为过去
    document.cookie = `${TokenKey}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
